(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('OrganoHierarchy', OrganoHierarchy);

    OrganoHierarchy.$inject = ['$resource'];

    function OrganoHierarchy ($resource) {
        var resourceUrl =  'public/api/aggs/organos';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
